/**
 * @generated SignedSource<<651f906ca9116c04a12e49da3e730e55>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_issueClassificationBadge_IssueClassificationBadge$data = {
  readonly classificationLevel: {
    readonly color: {
      readonly colorKey: string | null | undefined;
    } | null | undefined;
    readonly guidelines: string | null | undefined;
    readonly name: string | null | undefined;
  } | null | undefined;
  readonly fieldConfig: {
    readonly isEditable: boolean | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"editViewPopup_issueClassificationBadge_ClassificationEditViewPopup">;
  readonly " $fragmentType": "ui_issueClassificationBadge_IssueClassificationBadge";
};
export type ui_issueClassificationBadge_IssueClassificationBadge$key = {
  readonly " $data"?: ui_issueClassificationBadge_IssueClassificationBadge$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_issueClassificationBadge_IssueClassificationBadge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ui_issueClassificationBadge_IssueClassificationBadge",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "editViewPopup_issueClassificationBadge_ClassificationEditViewPopup"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "concreteType": "JiraFieldConfig",
      "kind": "LinkedField",
      "name": "fieldConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isEditable"
        }
      ]
    },
    {
      "concreteType": "JiraClassificationLevel",
      "kind": "LinkedField",
      "name": "classificationLevel",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "name"
        },
        {
          "kind": "ScalarField",
          "name": "guidelines"
        },
        {
          "concreteType": "JiraColor",
          "kind": "LinkedField",
          "name": "color",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "colorKey"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraDataClassificationField"
};

(node as any).hash = "23f7edf3b4c0bc4fd2061a70182a7b8c";

export default node;
